import { render } from "./SaveBrand.vue?vue&type=template&id=39debf20"
import script from "./SaveBrand.vue?vue&type=script&lang=js"
export * from "./SaveBrand.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__